import { ButtonTs } from '@lt/components';
import { useTranslation } from '@lt/localization';
import React from 'react';
import styled, { css } from 'styled-components';

type CustomerFillerButtonProps = {
  isMobile: boolean;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
};

const CustomerFillerButton = (props: CustomerFillerButtonProps) => {
  const { onClick, isMobile } = props;
  const { t } = useTranslation();
  return (
    <Button $isMobile={isMobile} variant="functional" onClick={onClick}>
      {t('checkout.customer.fill_tourists_data_button_text')}
    </Button>
  );
};

const Button = styled(ButtonTs)<{ $isMobile: boolean }>`
  font-size: 14px;
  display: inline;
  color: #007aff;

  ${(props) =>
    props.$isMobile &&
    css`
      margin-left: 8px;
    `}
`;

export default CustomerFillerButton;
